import { lazy } from 'react'

export const Management = lazy(() => import('./Management'))
